<template>

	<div class="container_page">
		<a-form layout="inline">
			<a-form-item label="搜索">
				<a-input placeholder="请输入关键字" v-model="filterData.keywords" />
			</a-form-item>
			<a-form-item>
				<a-button icon="search" class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button  @click="toSearch(false)">重置</a-button>
			</a-form-item>
		</a-form>
		<!-- 分类标签栏 -->
		<div class="cate">
			<a-radio-group v-model="filterData.tagTypeCategory" button-style="solid" @change="changeTab">
				<a-radio-button value="FACTORY">
					工厂
				</a-radio-button>
				<a-radio-button value="BRAND">
					品牌
				</a-radio-button>
				<a-radio-button value="SOCIAL_IDENTITY">
					社会评价身份
				</a-radio-button>
				<a-radio-button value="EXECUTION_STANDARD">
					执行标准
				</a-radio-button>

				<a-radio-button value="REPORT_REASON">
					举报原因
				</a-radio-button>
			</a-radio-group>
		</div>

		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="tagRender" slot-scope="text">
			<div v-if="text && text.length">
				<div>{{ text.map(item => item.tagName).join('、') }}</div>
				<div v-if="text.some(item => item.tagEnName)" style="color:#666;font-size:12px">{{ text.map(item => item.tagEnName).filter(Boolean).join('、') }}</div>
			</div>
		</template>
		<template slot="action" slot-scope="text, record">
				<a-button type="link" v-if="hasPermission('LABELSETTINGS_EDIT')" @click="toEdit(record)">编辑</a-button>
			</template>
		</a-table>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="sureEdit"
			@cancel="editModel.flag = false">
			<a-form-model ref="formRef" :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="标签分类" prop="tagCategoryName" required>
							<a-input style="width: 180px;" v-model="editModel.tagCategoryName" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="英文标签分类" prop="tagCategoryEnName" required>
							<a-input style="width: 180px;" v-model="editModel.tagCategoryEnName" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="标签名称" required>
							<div class="tag">
								<div class="tag-item" v-for="(item, index) of editModel.tags"
									:key="item.tagId || index"
									style="padding: 8px 24px 8px 10px;">
									<div style="display: flex; gap: 8px; align-items: center;">
										<a-input v-model="item.tagName" placeholder="中文标签" :maxLength="15" style="width: 250px;" />
										<a-input v-model="item.tagEnName" placeholder="英文标签" :maxLength="50" style="width: 250px;" />
									</div>
									<a-icon class="close-btn"
										style="position: absolute; top: 4px; right: 4px; font-size: 14px; color: #f00; cursor: pointer;"
										type="close" @click="handleDeleteTag(index)" />
								</div>
								<a-button type="dashed" size="small" icon="plus" @click="handleAddTag">
									添加
								</a-button>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		getTagCategoriesApi,
		getTagCategoryDetailApi,
		updateTagCategoryApi,
		toTranslateApi,
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				activeTab: 'FACTORY',
				rules: {
					tagCategoryName: [
						{ required: true, message: '请输入标签分类', trigger: 'blur' }
					],
					tagCategoryEnName: [
						{ required: true, message: '请输入英文标签分类', trigger: 'blur' }
					],
				},
				commodityStatusList: [{
						label: "开启",
						value: true,
					},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
						title: '序号',
						dataIndex: 'sort',
						key: 'sort',
						customRender: (text, record, index) => {
							return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
						}
					},
					{
						title: '标签分类',
						dataIndex: 'tagCategoryName',
						key: 'tagCategoryName'
					},
					{
						title: '标签名称',
						dataIndex: 'tags',
						key: 'tags',
						scopedSlots: {
							customRender: 'tagRender'
						}
					}, {
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				editModel: {
					"flag": false,
					"title": "",
					"tagCategoryId": null, //ID
					"tagTypeCategory": "", //标签类型
					"tagCategoryName": "", //标签分类 中文
					"tagCategoryEnName": "", //标签分类 英文
					"tags": [],
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: "",
					tagTypeCategory: "FACTORY"
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('labelSettings_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1);
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('labelSettings_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			hasPermission(permission) {
				const resources = this.$store.state.userInfo.resources;
				return resources && resources.split(";").includes(permission);
			},
			translate(){
				if (!this.editModel.tagCategoryName) return
				toTranslateApi({
						translationEn: this.editModel.tagCategoryName,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.editModel.tagCategoryEnName=res.resultData.translationEn

						} else {}
					})
			},
			handleDeleteTag(index) {
				this.editModel.tags.splice(index, 1)
			},
			handleTranslateTag(item) {
				if (!item.tagName) return
				toTranslateApi({
						translationEn: item.tagName,
					})
					.then((res) => {
						if (res.resultStatus) {
							  item.tagEnName = res.resultData.translationEn
						} else {}
					})
			},
			handleAddTag() {
				this.editModel.tags.push({
					tagId: 0,
					tagName: '',
					tagEnName: '',
					add: true,
				})
			},
			onTabChange(key) {
				console.log('Tab changed to:', key);
				this.filterData.tagTypeCategory = key;
				// 如果是接口请求数据，可以在这里调用接口
				this.getData();
			},
			changeTab(value) {
				console.log('Tab changed to:', value);
				this.filterData.tagTypeCategory = value.target.value;
				this.getData();
			},
			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						timeDate: [],
						keywords: "",
						tagTypeCategory: "FACTORY"
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getTagCategoriesApi({
						keywords: this.filterData.keywords,
						tagTypeCategory: this.filterData.tagTypeCategory
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData || [];

							// this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							// this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			sureEdit() {
				let hasTagError = false;
				if (this.editModel.tags.length == 0) {
					hasTagError = true;
				}
				const emptyTag = this.editModel.tags.some(item => !item.tagName)
				if (emptyTag) {
					hasTagError = true;
				}
				if (hasTagError) {
					this.$message.warning('请添加完整标签信息')
					return
				}
				this.$refs.formRef.validate((valid) => {
					if (!valid) return
					let tags = this.editModel.tags.map(item => {
					const newItem = {};
					// 只保留你需要的3个，且值不为空才加
					if (item.tagId !== undefined) newItem.tagId = item.tagId;
					if (item.tagName !== '') newItem.tagName = item.tagName;
					if (item.tagEnName !== '') newItem.tagEnName = item.tagEnName;
					return newItem;
				});
				updateTagCategoryApi({
						"tagCategoryId": this.editModel.tagCategoryId, //ID
						"tagTypeCategory": this.editModel.tagTypeCategory,
						"tagCategoryName": this.editModel.tagCategoryName, //标签分类 中文
						"tagCategoryEnName": this.editModel.tagCategoryEnName, //标签分类  英文
						"tags": tags
					})
					.then((res) => {
						if (res.resultStatus) {
							this.editModel.flag = false;
						} else {
							this.editModel.flag = false;
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						// this.loading = false;
						this.getData(this.pageInfo.current);
					});
				});
			},
			toEdit(data) {
				getTagCategoryDetailApi({
						tagCategoryId: data.tagCategoryId,
					})
					.then((res) => {
						if (res.resultStatus) {
							const result = res.resultData
							const titleMap = {
								'FACTORY': '工厂',
								'BRAND': '品牌',
								'SOCIAL_IDENTITY': '社会评价身份',
								'EXECUTION_STANDARD': '执行标准',
								'REPORT_REASON': '举报原因',
							}
							this.editModel = {
								"flag": true,
								"title": titleMap[result.tagTypeCategory] + '标签',
								"tagCategoryId": result.tagCategoryId, //ID
								"tagTypeCategory": result.tagTypeCategory, //标签类型
								"tagCategoryName": result.tagCategoryName, //标签分类 中文
								"tagCategoryEnName": result.tagCategoryEnName, //标签分类 英文
								"tags": result.tags || [],
								onOk: this.sureEdit,
							};
						} else {
							console.log("res");
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			confirm() {

			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.cate {
			margin: 20px 0;

			.ant-radio-button-wrapper {
				width: 130px !important;
				text-align: center !important;
			}
		}

		.mr12 {
			margin-right: 12px;
		}
	}

		.tag {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		gap: 10px;
		min-height: 40px;

		.tag-item {
			border-radius: 4px;
			display: flex;
			align-items: center;
			position: relative;

			.tagInput {
				width: 160px;
				border: none;
				background: transparent;
				outline: none;
				font-size: 16px;
				padding-right: 20px;
				color: #00BE80;

				&::placeholder {
					color: rgba(0, 190, 128, 0.5);
				}

				&:focus {
					box-shadow: none !important;
				}
			}

			/* 右上角关闭按钮核心样式 */
			.close-btn {
				position: absolute;
				top: 50%;
				right: 4px;
				transform: translateY(-50%);
				font-size: 14px;
				color: #999;
				cursor: pointer;
				z-index: 1;

				&:hover {
					color: #f00;
				}
			}

			.tag-text {
				font-size: 16px;
				color: #00BE80;
				white-space: nowrap;
			}
		}
	}
</style>
